'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.langs = [];
  }

  $onInit() {
    this.getTag();
  }

  getTag() {
    this.$http.get(`/api/tags/${this.$stateParams.id}`)
      .then(res => {
        this.tag = res.data;
        if (this.tag.langs) {
          this.langs = Object.entries(this.tag.langs);
        }
      });
  }

  save() {
    this.langs.forEach(lang => {
      if (!this.tag.langs) {
        this.tag.langs = {};
      }
      this.tag.langs[lang[0]] = lang[1];
    });

    this.$http.put(`/api/tags/${this.tag._id}`, this.tag).then(res => {
      this.$state.go('tags');
    });
  }

  addLang() {
    this.langs.push(new Array(2));
  }

}



// WEBPACK FOOTER //
// ./client/app/tags/edit/edit.controller.js